import {request,post,get} from '@/plugins/requestU'

/**
 * 维护企业信息
 * @param {*} data 
 * @returns 
 */
export function updateC(data) {
    return post('/guarantee/v0.1/guarantee/user/tc/updateC', data);
}
/**
 * 获取企业信息
 * @param {*} data 
 * @returns 
 */
export function detailC(data) {
    return post('/guarantee/v0.1/guarantee/user/tc/detailC', data);
}